var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"variant":_vm.project.status,"project":_vm.project,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }